const copyArray = (arrayToCopy) => {
    const newArray = [];
    for (const i in arrayToCopy)
        newArray.push(arrayToCopy[i])
    return newArray;
}

export default copyArray;